const SYNODIC_MONTH_DAYS = 29.530588853;
const REFERENCE_NEW_MOON_UTC = Date.UTC(2000, 0, 6, 18, 14, 0);

const PHASE_TARGETS = [
  { phase: 0, tag: 'new' },
  { phase: 0.25, tag: 'first-quarter' },
  { phase: 0.5, tag: 'full' },
  { phase: 0.75, tag: 'last-quarter' }
];

const circularDistance = (a, b) => {
  const diff = Math.abs(a - b);
  return Math.min(diff, 1 - diff);
};

/**
 * Returns the moon-phase tag ('new' | 'first-quarter' | 'full' | 'last-quarter')
 * for the calendar day nearest that phase, using real Earth moon cycles.
 * Returns null on days that aren't the closest match to any of the four phases.
 */
export const getMoonPhaseTag = (year, month, day) => {
  const dateUTC = Date.UTC(year, month, day, 12, 0, 0);
  const daysSinceReference = (dateUTC - REFERENCE_NEW_MOON_UTC) / 86400000;
  let phase = (daysSinceReference / SYNODIC_MONTH_DAYS) % 1;
  if (phase < 0) phase += 1;

  const halfDayStep = 1 / SYNODIC_MONTH_DAYS / 2;
  const nearest = PHASE_TARGETS.find((target) => circularDistance(phase, target.phase) <= halfDayStep);
  return nearest ? nearest.tag : null;
};
